import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {environment} from '../../../../environments/environment';

import {PlayerService} from '../../core/services/player/player.service';
import {Show} from '../../../services/archive.model';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {

    public archivePlaying: boolean;
    public inArchive = false;

    //public chatEnabled = !(window.location.hostname === environment.iOSAppDomain);
    public chatEnabled = true;

    constructor(private router: Router, private playerService: PlayerService) {
        router.events.pipe(
            filter(e => e instanceof NavigationEnd)
        ).subscribe((val: NavigationEnd) => {
            this.inArchive = val.urlAfterRedirects === '/archive';
        });
        this.playerService.currentlyPlaying.subscribe((currentlyPlaying: Show) => this.archivePlaying = !!currentlyPlaying);
    }

    ngOnInit(): void {
    }

}
